import { render, staticRenderFns } from "./TreasuriesTransactionsTable.vue?vue&type=template&id=0dba6f3a&"
import script from "./TreasuriesTransactionsTable.vue?vue&type=script&lang=js&"
export * from "./TreasuriesTransactionsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports